import { useCallback, useEffect, useState } from "react";
import { Avatar, Box, Grid, Typography } from "@mui/material";
import WarningIcon from "../IconComp/warningIcon";
import ToolbarButton from "../common/Toolbar-button";
import AppModal from "../common/AppModal";
import AddBatchModal from "./profile-edit-model";
import AppSnackbar from "../common/AppSnackbar";
import EditProfileModal from "./profile-edit-model";
import EditIcon from "../IconComp/editIcon";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getProfileData } from "../../features/profile/profileSlice";
import AppIcon from "../common/AppIcon";
import CustomIcon from "../common/CustomIcon";
import { getPharmacyImage } from "../../utils/utils";
import { useSelector } from "react-redux";

interface IProps {
  profileInfo: any;
  clinicProfile: any;
  getProfile: () => void;
  profileData: any;
}

export const ProfileModal = ({
  profileInfo,
  //getProfile,
  clinicProfile,
  profileData,
}: IProps) => {
  const [isEditing, setIsEditing] = useState(false); // State to track if editing mode is active
  const [openModal, setOpenModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const dispatch = useAppDispatch();
  const storedData: any = localStorage.getItem("pharmacyAuthToken");
  const parsedData = JSON.parse(storedData);
  const pharmacyId = localStorage?.getItem("pharmacyId");
  const Account_Type = parseInt(localStorage?.getItem("pharmacy_account_type") || "0", 10);

  // Use useAppSelector to access Redux state
  const profiledata: any = useAppSelector(
    (state: any) => state.profile.profileDetails
  );

  const getProfile = useCallback(() => {
    dispatch(getProfileData(pharmacyId));
  }, [dispatch]);

  useEffect(() => {
    getProfile();
  }, [getProfile]);

  const handleToggleEdit = () => {
    setIsEditing(!isEditing);
  };

  const formattedDate = profiledata?.user?.license_expire_date
    ? new Date(profiledata.user.license_expire_date).toLocaleDateString("en-GB")
    : "-";    




  return (
    <>
      <Box
        sx={{
          py: 4,
          px: 5,
          position: "relative",
          bgcolor: "white",
        }}
      >
        {isEditing ? ( // If editing mode is active, render the edit form
          <EditProfileModal
            profile={profiledata}
            handleClose={() => setIsEditing(false)} // Callback to close the edit form
            setOpenSnackbar={() => setOpenSnackbar(true)}
            getProfile={getProfile}
          />
        ) : (profiledata?.pharmacy || profiledata?.user) === null ? (
          <Box
            sx={{
              color: "secondary.main",
              fontWeight: "600",
              fontSize: "28px",
              textAlign: "center",
            }}
          >
            Pharmacy Owner / Admin Not Found
          </Box>
        ) : (
          <Grid container spacing={3}>
            {/* Avatar Section */}
            <Grid item>
              <Avatar
                src={getPharmacyImage(profiledata?.pharmacy?.id)}
                sx={{ width: 170, height: 170 }}
              />
            </Grid>

            {/* Details Section */}
            <Grid item xs={8}>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                <Typography
                  sx={{
                    color: "secondary.main",
                    fontWeight: "600",
                    fontSize: "28px",
                  }}
                  variant="h4"
                >
                  Pharmacy Name:{" "}
                  <span style={{ fontWeight: "600" }}>
                    {profiledata?.pharmacy?.name}
                  </span>
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 15,
                    marginTop: 3,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                    }}
                  >
                    <Typography
                      sx={{ fontWeight: "400", fontSize: "16px", flex: 1 }}
                      variant="h6"
                    >
                      City:{" "}
                      <span style={{ fontWeight: "600" }}>
                        {profiledata?.pharmacy?.address?.city}
                      </span>
                    </Typography>
                    <Typography
                      sx={{ fontWeight: "400", fontSize: "16px" }}
                      variant="body2"
                    >
                      Email:{" "}
                      <span style={{ fontWeight: "600" }}>
                        {profiledata?.pharmacy?.email}
                      </span>
                    </Typography>
                    <Typography
                      sx={{ fontWeight: "400", fontSize: "16px" }}
                      variant="body2"
                    >
                      Reg Number:{" "}
                      <span style={{ fontWeight: "600" }}>
                        {profiledata?.user?.pharmacy_reg
                          ? profiledata?.user?.pharmacy_reg
                          : "-"}
                      </span>
                    </Typography>
                    <Typography
                      sx={{ fontWeight: "400", fontSize: "16px" }}
                      variant="body2"
                    >
                      License Expiry:{" "}
                      <span style={{ fontWeight: "600" }}>{formattedDate}</span>
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                    }}
                  >
                    <Typography
                      sx={{ fontWeight: "400", fontSize: "16px", flex: 1 }}
                      variant="h6"
                    >
                      Address:{" "}
                      <span style={{ fontWeight: "600" }}>
                        {profiledata?.pharmacy?.address?.address}
                      </span>
                    </Typography>
                    <Typography
                      sx={{ fontWeight: "400", fontSize: "16px" }}
                      variant="body2"
                    >
                      Customer Service #:{" "}
                      <span style={{ fontWeight: "600" }}>
                        {profiledata?.user?.contact_number}
                      </span>
                    </Typography>
                    <Typography
                      sx={{ fontWeight: "400", fontSize: "16px" }}
                      variant="body2"
                    >
                      License Number #:{" "}
                      <span style={{ fontWeight: "600" }}>
                        {profiledata?.user?.license_number
                          ? profiledata?.user?.license_number
                          : "-"}
                      </span>
                    </Typography>
                    <Typography
                      sx={{ fontWeight: "400", fontSize: "16px" }}
                      variant="body2"
                    >
                      Operating Hours:{" "}
                      <span style={{ fontWeight: "600" }}>
                        {profiledata?.pharmacy?.operating_hours
                          ? profiledata?.pharmacy?.operating_hours
                          : "-"}
                      </span>
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>

            {/* Edit Icon */}
            <Grid item xs={4}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                  position: "absolute",
                  top: 0,
                  right: 0,
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  padding: "5px",
                }}
              >
                {Account_Type === 0 && (
                  <button
                    onClick={handleToggleEdit}
                    style={{
                      border: "none",
                      background: "none",
                      cursor: "pointer",
                    }}
                  >
                    <EditIcon />
                  </button>
                )}
              </Box>
            </Grid>
          </Grid>
        )}
      </Box>

      {/* <AppModal
        title="Pharmacy Profile"
        open={openModal}
        handleClose={handleCloseModal}
        fullScreen={false}
        maxWidth="lg"
      >
        <EditProfileModal
          handleClose={handleCloseModal}
          setOpenSnackbar={() => setOpenSnackbar(true)}
          getProfile={getProfile}
          profile={profiledata}
          //clinicProfile={clinicProfile}
          //getClinicProfile={getClinicProfile}
        />
      </AppModal>
      <AppSnackbar
        message="Successfully Updated!"
        open={openSnackbar}
        handleClose={() => setOpenSnackbar(false)}
      /> */}
    </>
  );
};
